import React, { useEffect, useState } from 'react';
import { apiJson } from '../api';

const emptyForm = { username: '', email: '', password: '', name: '', role: 'operator', allowedDevices: [] };

const Users = () => {
  const [users, setUsers] = useState([]);
  const [devices, setDevices] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState('');

  const load = async () => {
    const [{ data: usersData }, { data: devicesData }] = await Promise.all([
      apiJson('/api/users'),
      apiJson('/api/devices?lite=1')
    ]);
    if (Array.isArray(usersData?.users)) setUsers(usersData.users);
    if (Array.isArray(devicesData)) setDevices(devicesData);
  };

  useEffect(() => { load(); }, []);

  const toggleDevice = (id) => {
    setForm((prev) => ({
      ...prev,
      allowedDevices: prev.allowedDevices.includes(id)
        ? prev.allowedDevices.filter((item) => item !== id)
        : [...prev.allowedDevices, id]
    }));
  };

  const save = async (e) => {
    e.preventDefault();
    setError('');
    const payload = { ...form, allowedDevices: form.role === 'admin' ? [] : form.allowedDevices };
    if (editingId && !payload.password) delete payload.password;
    const { res, data } = await apiJson(editingId ? `/api/users/${editingId}` : '/api/users', {
      method: editingId ? 'PUT' : 'POST',
      body: JSON.stringify(payload)
    });
    if (!res.ok) return setError(data.error || 'Save failed');
    setForm(emptyForm);
    setEditingId(null);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('Delete user?')) return;
    await apiJson(`/api/users/${id}`, { method: 'DELETE' });
    load();
  };

  return (
    <div className="grid" style={{ gridTemplateColumns: '0.9fr 1.1fr' }}>
      <form className="card" onSubmit={save}>
        <h3 style={{ marginTop: 0 }}>{editingId ? 'Edit user' : 'Create user'}</h3>
        {error && <div style={{ color: '#a23d2f', marginBottom: 12 }}>{error}</div>}
        <label className="field"><span>Name</span><input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></label>
        <label className="field"><span>Email</span><input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required /></label>
        <label className="field"><span>Username</span><input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} /></label>
        <label className="field"><span>Password</span><input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required={!editingId} /></label>
        <label className="field">
          <span>Role</span>
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
            <option value="operator">Operator</option>
            <option value="admin">Admin</option>
          </select>
        </label>
        {form.role === 'operator' && devices.map((device) => (
          <label key={device.id} style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <input type="checkbox" checked={form.allowedDevices.includes(device.id)} onChange={() => toggleDevice(device.id)} />
            {device.id}
          </label>
        ))}
        <button className="btn" type="submit">{editingId ? 'Update' : 'Create'}</button>
      </form>
      <div className="card">
        <table className="table">
          <thead><tr><th>User</th><th>Role</th><th>Devices</th><th /></tr></thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.name}<div style={{ color: '#6a756e' }}>{user.email || user.username}</div></td>
                <td>{user.role}</td>
                <td>{user.role === 'admin' ? 'All' : (user.allowedDevices || []).join(', ') || 'None'}</td>
                <td>
                  <button className="btn light" onClick={() => { setEditingId(user.id); setForm({ ...emptyForm, ...user, password: '' }); }}>Edit</button>
                  {' '}
                  <button className="btn danger" onClick={() => remove(user.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Users;
